import { Text, TextProps } from "@shopify/polaris";
import React from "react";

interface Props extends TextProps {}

export function PolarisText(props: Props) {
  return <Text {...props}>{props.children}</Text>;
}
